import { PortfoliosVersionsService_portfolioVersionsServiceV3GetEntity } from '@festina/unitlink-general-types/unitlink/hooks/PortfoliosVersionsService_portfolioVersionsServiceV3GetEntity'

export const useLazyFetchPortfolioByEventId =
  PortfoliosVersionsService_portfolioVersionsServiceV3GetEntity.useLazyQuery
